import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle } from "vue"

import { computed } from 'vue';
import CollageTileDefaultLayoutGridOptionA
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutGridOptionA.vue';
import CollageTileDefaultLayoutGridOptionB
    from '@/shared/content/blocks/collage-layouts/default-layout-helpers/CollageTileDefaultLayoutGridOptionB.vue';
import breakpointsState from '@/core/responsive/breakpoints/breakpoints-state.observable';
import TextBlockHandler from '@/shared/content/blocks/helpers/TextBlockHandler.vue';
import { CollageTileLayout } from '@/shared/content/blocks/collage-layouts/collage-layout.store';
import Swiper from '@/shared/Swiper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CollageTileDefaultLayout',
  props: {
    content: null,
    isReversedLayout: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { content: CollageTileLayout, isReversedLayout: boolean }



const tileModelData = computed(() => {
    const array: any = [];
    let currentPos = -1;

    props.content.tiles.forEach((tile: any, index: number) => {
        if (index % 3 === 0) {
            currentPos++;
        }
        Array.isArray(array[currentPos]) ? array[currentPos].push(tile.model) : array[currentPos] = [tile.model];
    });

    return array;
});

const textColorClass = computed(() => {
    return props.content.textColor ? `color: ${props.content.textColor}` : null;
});

const useGridOptionA = (index: number): boolean => {
    return props.isReversedLayout ? index % 2 !== 0 : index % 2 === 0;
};

const useGridOptionB = (index: number): boolean => {
    return props.isReversedLayout ? index % 2 === 0 : index % 2 !== 0;
};

const mirrorGrid = (index: number): boolean => {
    const mirrorGridOnFirstSlide = props.content.mirrorLayoutOnFirstSlide && index === 0;
    return index === 2 || index === 3 || mirrorGridOnFirstSlide;
};

const isFirstOrSlide = (index: number): boolean => {
    return index + 1 === tileModelData.value.length || index === 0;
};

const isMobileOrTablet = computed(() => breakpointsState.activeBreakpoint === 'xs' || breakpointsState.activeBreakpoint === 'sm');


return (_ctx: any,_cache: any) => {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!

  return (_openBlock(), _createElementBlock("section", {
    class: "relative",
    style: _normalizeStyle(_unref(textColorClass))
  }, [
    _createVNode(TextBlockHandler, {
      class: "md:w-1/2 text-black mr-auto mx-20 mb-20 md:mx-10 md:mb-15",
      title: __props.content.title,
      heading: __props.content.subheading,
      text: __props.content.text
    }, null, 8, ["title", "heading", "text"]),
    (_unref(tileModelData).length > 1)
      ? (_openBlock(), _createBlock(Swiper, {
          key: 0,
          class: "c-swiper-teaser-overlay",
          "free-mode": _unref(isMobileOrTablet),
          options: { spaceBetween: 15 }
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tileModelData), (section, blockListIndex) => {
              return (_openBlock(), _createBlock(_component_SwiperSlide, {
                key: blockListIndex,
                class: _normalizeClass({'c-swiper-teaser-overlay__option-A': useGridOptionA(blockListIndex),
                                  'c-swiper-teaser-overlay__option-B': useGridOptionB(blockListIndex)})
              }, {
                default: _withCtx(() => [
                  (useGridOptionA(blockListIndex))
                    ? (_openBlock(), _createBlock(CollageTileDefaultLayoutGridOptionA, {
                        key: 0,
                        "tile-model-data": section,
                        "is-first-or-last": isFirstOrSlide(blockListIndex),
                        "mirror-grid": mirrorGrid(blockListIndex)
                      }, null, 8, ["tile-model-data", "is-first-or-last", "mirror-grid"]))
                    : (useGridOptionB(blockListIndex))
                      ? (_openBlock(), _createBlock(CollageTileDefaultLayoutGridOptionB, {
                          key: 1,
                          "tile-model-data": section,
                          "is-first-or-last": isFirstOrSlide(blockListIndex),
                          "mirror-grid": mirrorGrid(blockListIndex)
                        }, null, 8, ["tile-model-data", "is-first-or-last", "mirror-grid"]))
                      : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["free-mode"]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["mx-10", {'c-swiper-teaser-overlay__option-A': useGridOptionA(0),
                      'c-swiper-teaser-overlay__option-B': useGridOptionB(0)}])
        }, [
          (useGridOptionA(0))
            ? (_openBlock(), _createBlock(CollageTileDefaultLayoutGridOptionA, {
                key: 0,
                "tile-model-data": _unref(tileModelData)[0],
                "is-first-or-last": true,
                "mirror-grid": mirrorGrid(0)
              }, null, 8, ["tile-model-data", "mirror-grid"]))
            : (useGridOptionB(0))
              ? (_openBlock(), _createBlock(CollageTileDefaultLayoutGridOptionB, {
                  key: 1,
                  "tile-model-data": _unref(tileModelData)[0],
                  "is-first-or-last": true,
                  "mirror-grid": mirrorGrid(0)
                }, null, 8, ["tile-model-data", "mirror-grid"]))
              : _createCommentVNode("", true)
        ], 2))
  ], 4))
}
}

})